import { message } from 'antd';
import * as API from '@/services/api';

export default {
  namespace: 'role',
  state: {
    roleList: [],
    roleParams: {},
    rolePagination: {},
    memberList: [],
    memberParams: {},
    memberPagination: {},
  },
  effects: {
    *getRoleList({ payload }, { call, put, select }) {
      const params = yield select((state) => state.role.roleParams);
      const res = yield call(API.getRoleList, { ...params, ...payload });
      if (res.code === 0) {
        const data = res.data;
        yield put({
          type: 'save',
          payload: {
            roleList: data.data,
            roleParams: { ...params, ...payload },
            rolePagination: data.pagination,
          },
        });
      }
    },

    *addRole({ payload }, { call, put }) {
      const res = yield call(API.addRole, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getRoleList',
        });
      } else {
        message.error(res.message);
      }
    },
    *delRole({ payload }, { call, put }) {
      const res = yield call(API.delRole, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getRoleList',
        });
      } else {
        message.error(res.message);
      }
    },
    *editRole({ payload }, { call, put }) {
      const res = yield call(API.editRole, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getRoleList',
        });
      } else {
        message.error(res.message);
      }
    },

    *getRoleMemberList({ payload }, { call, put, select }) {
      const params = yield select((state) => state.role.memberParams);
      const res = yield call(API.getRoleMemberList, { ...params, ...payload });
      if (res.code === 0) {
        const data = res.data;
        yield put({
          type: 'save',
          payload: {
            memberList: data.data,
            memberParams: { ...params, ...payload },
            memberPagination: data.pagination,
          },
        });
      }
    },

    *addRoleMember({ payload }, { call, put }) {
      const res = yield call(API.addRoleMember, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getRoleMemberList',
        });
        yield put({
          type: 'getRoleList',
        });
      } else {
        message.error(res.message);
      }
    },
    *delRoleMember({ payload }, { call, put }) {
      const res = yield call(API.delRoleMember, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getRoleMemberList',
        });
        yield put({
          type: 'getRoleList',
        });
      } else {
        message.error(res.message);
      }
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};
